import { george, pr } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { observer } from "mobx-react";
import * as React from "react";

interface SavingsOptionsActionCardProps {
    title: string;
    content: React.ReactNode;
    image: string;
    actionButtonText: string;
    onClickActionButton: () => void;
    isMobile?: boolean;
}

export const SavingsOptionsActionCard = observer(({
    title,
    content,
    image,
    actionButtonText,
    onClickActionButton,
    isMobile,
}: SavingsOptionsActionCardProps) => (
    <george.Card
        disableTopSpacing
        style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            borderRadius: 8,
            boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.05)"
        }}
    >
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#028661",
                borderRadius: isMobile ? "8px 8px 0px 0px" : "8px 0px 0px 8px",
                overflow: "hidden",
                minWidth: 200,
                maxWidth: isMobile ? "100%" : 200,
                minHeight: 200,
                maxHeight: isMobile ? 200 : "100%",
            }}
        >
            <img
                src={image}
                style={{ minWidth: "100%", minHeight: "100%", objectFit: "cover" }}
                alt={title}
            />
        </div>
        <div style={{ padding: 24 }}>
            <pr.P_18_TITLE style={{ lineHeight: "24px", fontWeight: 700 }}>
                {title}
            </pr.P_18_TITLE>
            <div style={{ display: "flex", flexDirection: "column", gap: 4, lineHeight: "21px", marginTop: 9 }}>
                {content}
            </div>
        </div>
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                borderRadius: isMobile ? "0px 0px 8px 8px" : "0px 8px 8px 0px",
                padding: 24,
                paddingLeft: isMobile ? 24 : 0
            }}
        >
            <GdsFakeActionButton color="primary" onClick={onClickActionButton}>
                {actionButtonText}
            </GdsFakeActionButton>
        </div>
    </george.Card>
)); 


// WEBPACK FOOTER //
// ./src/components/savingsOptions/components/SavingsOptionsActionCard.tsx